import { ConsultingFeePercentageVetCreate } from '../components/ConsultingFeePercentageVet/ConsultingFeePercentageVetCreate';
import { ConsultingFeePercentageVetEdit } from '../components/ConsultingFeePercentageVet/ConsultingFeePercentageVetEdit';

export const ConsultingFeePercentageVet = {
  create: ConsultingFeePercentageVetCreate,
  edit: ConsultingFeePercentageVetEdit
};